// Constantes base para rutas
const COMMUNICATION_BASE = '/communication';
const REPORTS_BASE = '/report';
const OBSERVATORY_BASE = '/observatory';

export const ROUTES = {
  PUBLIC: {
    ROOT: '/',
    LOGIN: '/login',
    CALLBACK: '/callback',
  },
  
  MAIN: {
    HOME: '/home',
    USERS: '/users',
    PROFILE: '/profile',
    MONITOR: '/monitor',
    NOTIFICATIONS: '/notifications',
  },
  
  COMMUNICATION: {
    ROOT: COMMUNICATION_BASE,
    LIST_ALERTS: `${COMMUNICATION_BASE}/list-alerts`,
    LIST_ALERTS_BY_TYPE: `${COMMUNICATION_BASE}/list-alerts/:phenomenonType`,
    CREATE_FORECAST: `${COMMUNICATION_BASE}/create-forecast`,
    CREATE_MULTIPLE_FORECAST: `${COMMUNICATION_BASE}/create-multiple-forecast`,
    INFO: `${COMMUNICATION_BASE}/info`,
    INFO_TYPES: {
      GENERAL: `${COMMUNICATION_BASE}/info/general`,
      TRAFFIC: `${COMMUNICATION_BASE}/info/traffic`,
      SECURITY: `${COMMUNICATION_BASE}/info/security`,
    },
    NEWS: `${COMMUNICATION_BASE}/news`,
    PHENOMENON: `${COMMUNICATION_BASE}/phenomenon`,
    // Subrutas de fenómenos
    PHENOMENON_TYPES: {
      FLOOD: `${COMMUNICATION_BASE}/phenomenon/flood`,
      STORM: `${COMMUNICATION_BASE}/phenomenon/storm`,
      WIND: `${COMMUNICATION_BASE}/phenomenon/wind`,
      DRILL: `${COMMUNICATION_BASE}/phenomenon/drill`,
      FROST: `${COMMUNICATION_BASE}/phenomenon/frost`,
      TROPICAL_CYCLONE: `${COMMUNICATION_BASE}/phenomenon/tropical-cyclone`,
      FOREST_FIRE: `${COMMUNICATION_BASE}/phenomenon/forest-fire`,
      VOLCANIC: `${COMMUNICATION_BASE}/phenomenon/volcanic`,
      LOW_TEMPERATURES: `${COMMUNICATION_BASE}/phenomenon/low-temperatures`,
      HIGH_TEMPERATURES: `${COMMUNICATION_BASE}/phenomenon/high-temperatures`,
      EARTHQUAKE: `${COMMUNICATION_BASE}/phenomenon/earthquake`,
      TSUNAMI: `${COMMUNICATION_BASE}/phenomenon/tsunami`,
      ENVIRONMENTAL_RISK: `${COMMUNICATION_BASE}/phenomenon/environmental_risk`,
      SILENT: `${COMMUNICATION_BASE}/phenomenon/silent`,
      HAIL: `${COMMUNICATION_BASE}/phenomenon/hail`,
      DUST_DEVIL: `${COMMUNICATION_BASE}/phenomenon/dust-devil`,
    },
    
    // Subrutas de detalles de alertas
    ALERT_DETAILS: {
      FROST: `${COMMUNICATION_BASE}/alert-details/frost/:id`,
      TROPICAL_CYCLONE: `${COMMUNICATION_BASE}/alert-details/tropical_cyclone/:id`,
      FOREST_FIRE: `${COMMUNICATION_BASE}/alert-details/forest_fire/:id`,
      VOLCANIC: `${COMMUNICATION_BASE}/alert-details/volcanic/:id`,
      LOW_TEMPERATURES: `${COMMUNICATION_BASE}/alert-details/low_temperatures/:id`,
      HIGH_TEMPERATURES: `${COMMUNICATION_BASE}/alert-details/high_temperatures/:id`,
      EARTHQUAKE: `${COMMUNICATION_BASE}/alert-details/earthquake/:id`,
      TSUNAMI: `${COMMUNICATION_BASE}/alert-details/tsunami/:id`,
      STORM: `${COMMUNICATION_BASE}/alert-details/storm/:id`,
      FLOOD: `${COMMUNICATION_BASE}/alert-details/flood/:id`,
      DRILL: `${COMMUNICATION_BASE}/alert-details/drill/:id`,
      TEMP_FLOOD: `${COMMUNICATION_BASE}/alert-details/temp_flood/:id`,
      WIND: `${COMMUNICATION_BASE}/alert-details/wind/:id`,
      INFO: `${COMMUNICATION_BASE}/alert-details/info/:id`,
      NEWS: `${COMMUNICATION_BASE}/alert-details/news/:id`,
      FORECAST: `${COMMUNICATION_BASE}/alert-details/forecast/:id`,
      ENVIRONMENTAL_RISK: `${COMMUNICATION_BASE}/alert-details/environmental_risk/:id`,
      HAIL: `${COMMUNICATION_BASE}/alert-details/hail/:id`,
      DUST_DEVIL: `${COMMUNICATION_BASE}/alert-details/dust_devil/:id`,
    },
  },
  
  REPORTS: {
    ROOT: REPORTS_BASE,
    EDL: `${REPORTS_BASE}/edl`,
    ANALYTICS: `${REPORTS_BASE}/analytics`,
    DEMOGRAPHIC_GRAPHS: `${REPORTS_BASE}/demographic-graphs`,
  },
  
  OBSERVATORY: {
    ROOT: OBSERVATORY_BASE,
    CONDICIONES_METEOROLOGICAS: `${OBSERVATORY_BASE}/condiciones-meteorologicas`,
    EVENTOS_TORMENTA: `${OBSERVATORY_BASE}/eventos-tormenta`,
    MONITOREO_AMBIENTAL: `${OBSERVATORY_BASE}/monitoreo-ambiental`,
    MONITOREO_VOLCANICO: `${OBSERVATORY_BASE}/monitoreo-volcanico`,
  },
} as const;

// Tipos para TypeScript
export type RouteKeys = keyof typeof ROUTES;
export type CommunicationRoutes = typeof ROUTES.COMMUNICATION;
export type PhenomenonRoutes = typeof ROUTES.COMMUNICATION.PHENOMENON_TYPES;
export type AlertDetailsRoutes = typeof ROUTES.COMMUNICATION.ALERT_DETAILS;
